<template>
    <div
        ref="onboardingContainer"
        class="m-0 items-center justify-between px-4 py-2"
        :class="{ 'relative overflow-hidden': hasSliders }"
    >
        <div class="m-0 items-center justify-between px-2 py-2" :class="{ 'relative overflow-hidden': hasSliders }">
            <div v-show="position === 0" class="relative w-full cursor-default select-none">
                <div class="mb-2 w-full text-center">
                    <h2 class="text-lg font-semibold text-blue-500 sm:text-xl md:text-2xl dark:text-purple-400">
                        {{ step.title }}
                    </h2>
                    <h3
                        v-if="step.subTitle"
                        :class="[
                            'text-base font-medium text-blue-500 sm:text-lg md:text-xl dark:text-purple-400',
                            { 'mb-2': step.subTitle !== ' ' },
                        ]"
                    >
                        {{ step.subTitle }}
                    </h3>
                </div>

                <div class="flex w-full items-center justify-center py-2">
                    <div class="flex h-[280px] w-full items-center justify-center">
                        <img
                            draggable="false"
                            :src="getImage(step.image)"
                            :alt="step.title"
                            class="max-h-full max-w-full object-contain"
                        />
                    </div>
                </div>

                <div class="w-full">
                    <p class="mb-0">{{ step.paragraph }}</p>
                </div>
                <div class="w-full">
                    <p class="mb-0">{{ step.extraParagraph }}</p>
                </div>

                <div class="h-14 w-full">
                    <div v-if="step.step_name === 'app-promote'" class="mt-3 flex w-full justify-center">
                        <ul class="flex list-none justify-center gap-3 p-0">
                            <li v-if="!isAndroid">
                                <a :href="promoteApp.appleAppLink">
                                    <img
                                        :alt="localizations[lang].promoteApp.downloadAppStore"
                                        :src="badges.apple"
                                        class="h-8"
                                    />
                                </a>
                            </li>
                            <li v-if="!isApple">
                                <a :href="promoteApp.androidAppLink">
                                    <img
                                        :alt="localizations[lang].promoteApp.downloadPlayStore"
                                        :src="badges.android"
                                        class="h-8"
                                    />
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div v-for="(slider, index) in step.sliders" :key="index">
                <div v-if="position === index + 1" class="relative w-full cursor-default select-none overflow-hidden">
                    <div class="w-full text-center">
                        <h2 class="text-2xl font-medium">{{ slider.title }}</h2>
                    </div>
                    <div class="flex w-full items-center justify-center">
                        <div class="flex h-[280px] w-full items-center justify-center">
                            <img
                                draggable="false"
                                :src="getImage(slider.image)"
                                :alt="step.title"
                                class="max-h-full max-w-full object-contain"
                            />
                        </div>
                    </div>
                    <div class="w-full text-center">
                        <p class="mb-0">{{ slider.paragraph }}</p>
                    </div>
                </div>
            </div>

            <div v-if="hasSliders" class="absolute inset-y-0 flex w-full justify-between">
                <button
                    v-show="position > 0"
                    type="button"
                    :aria-label="localizations[lang].tooltips.prev"
                    class="absolute inset-y-0 left-0 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                    @click="previousSlider"
                >
                    <svg-icon icon="ic_keyboard_arrow_left_white_24px" aria-hidden="true"></svg-icon>
                </button>
                <button
                    v-show="position !== lengthSliders"
                    type="button"
                    :aria-label="localizations[lang].tooltips.next"
                    class="absolute inset-y-0 right-0 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                    @click="nextSlider"
                >
                    <svg-icon icon="ic_keyboard_arrow_right_white_24px" aria-hidden="true"></svg-icon>
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
export default {
    name: 'OnboardingStep',
    props: {
        step: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            position: 0,
        };
    },
    computed: {
        ...mapState(['localizations', 'lang', 'promoteApp']),
        ...mapGetters(['isAndroid', 'isApple']),
        hasSliders() {
            return this.step.sliders && this.step.sliders.length > 0;
        },
        lengthSliders() {
            return this.step.sliders.length;
        },
        badges() {
            return {
                android: `${process.env.VITE_URL}/volpe-assets/images/stores-badges/google-play-badge_${this.lang}.png`,
                apple: `${process.env.VITE_URL}/volpe-assets/images/stores-badges/apple-store-badge_${this.lang}.png`,
            };
        },
        subtitleClasses() {
            return {
                'mb-5 font-medium text-xl text-blue-500 dark:text-purple-400': true,
                'mb-8 text-blue-500 dark:text-purple-400': this.step.subTitle === '\n',
            };
        },
    },
    methods: {
        getImage(name) {
            return `${process.env.VITE_URL}/volpe-assets/images/${name}`;
        },
        nextSlider() {
            if (this.lengthSliders === this.position) return;
            this.position++;
        },
        previousSlider() {
            if (this.position === 0) return;
            this.position--;
        },
    },
};
</script>
